module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('app-loading') : _c('section', {
    class: ['login', _vm.darkMode ? 'dark' : 'light']
  }, [_c('div', {
    staticClass: "wrapper-login"
  }, [_c('button', {
    staticClass: "btn-theme-toggle",
    attrs: {
      "title": _vm.darkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'
    },
    on: {
      "click": _vm.toggleDarkMode
    }
  }, [(_vm.darkMode) ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0z"
    }
  })]) : _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998z"
    }
  })])]), _vm._v(" "), _vm._l((30), function(n) {
    return _c('span', {
      key: n,
      staticClass: "bubble"
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doLogin.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "mb-8"
  }, [_c('img', {
    staticClass: "w-32 xl:block mx-auto mb-5",
    attrs: {
      "alt": "Logo",
      "src": "/static/images/LOGO-WHITE-2026.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ingresa tu usuario:")]), _vm._v(" "), _c('div', {
    staticClass: "box-input-user mt-4 mb-4 intro-x"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.email) ? _c('small', {
    staticClass: "text-red-600 -mt-2 flex"
  }, [_vm._v(_vm._s(_vm.errors.email[0]))]) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ingresa tu contraseña:")]), _vm._v(" "), _c('div', {
    staticClass: "box-input-pass mt-2 intro-x"
  }, [((_vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.password) ? _vm._i(_vm.user.password, null) > -1 : (_vm.user.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "password", $$c)
        }
      }
    }
  }) : ((_vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.user.password, null)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.user, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Password",
      "type": _vm.type
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute top-0 right-0 rounded-r w-10 h-full flex mr-1 items-center justify-center text-gray-600 cursor-pointer",
    on: {
      "click": _vm.viewPassClick
    }
  }, [(!_vm.viewPass) ? _c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }
  })]) : _c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
    }
  })])])]), _vm._v(" "), (_vm.errors.password) ? _c('small', {
    staticClass: "text-red-600 mt-2 flex"
  }, [_vm._v(_vm._s(_vm.errors.password[0]))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "intro-x mt-5 text-center"
  }, [_c('button', {
    staticClass: "button-login button w-full !text-white"
  }, [_vm._v("\n            Ingresar\n          ")])])])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07618fd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Login.vue
// module id = 405
// module chunks = 1